import React from 'react';

const Logo = () => {
  // Function to handle logo click
  const handleLogoClick = () => {
    // If we're not at the top of the page, scroll to top
    if (window.scrollY !== 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
      <svg width="180" height="80" viewBox="0 0 180 80" xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(40, 5)">
          {/* Neural Network Sphere */}
          <g className="network-sphere">
            {/* Nodes */}
            <circle cx="50" cy="30" r="3" fill="#3498db" />
            <circle cx="35" cy="20" r="3" fill="#3498db" />
            <circle cx="65" cy="20" r="3" fill="#3498db" />
            <circle cx="30" cy="35" r="3" fill="#3498db" />
            <circle cx="70" cy="35" r="3" fill="#3498db" />
            <circle cx="50" cy="15" r="3" fill="#3498db" />
            <circle cx="50" cy="45" r="3" fill="#3498db" />
            <circle cx="25" cy="25" r="3" fill="#3498db" />
            <circle cx="75" cy="25" r="3" fill="#3498db" />
            <circle cx="40" cy="40" r="3" fill="#3498db" />
            <circle cx="60" cy="40" r="3" fill="#3498db" />
            <circle cx="20" cy="40" r="3" fill="#3498db" />
            <circle cx="80" cy="40" r="3" fill="#3498db" />
            
            {/* Small nodes with opacity */}
            <circle cx="85" cy="30" r="1.5" fill="#3498db" opacity="0.7" />
            <circle cx="90" cy="35" r="1.5" fill="#3498db" opacity="0.6" />
            <circle cx="88" cy="25" r="1.5" fill="#3498db" opacity="0.5" />
            <circle cx="92" cy="20" r="1" fill="#3498db" opacity="0.4" />
            <circle cx="95" cy="30" r="1" fill="#3498db" opacity="0.3" />
            <circle cx="93" cy="40" r="1" fill="#3498db" opacity="0.4" />
            <circle cx="85" cy="45" r="1" fill="#3498db" opacity="0.5" />
            
            {/* Connection lines */}
            <line x1="50" y1="30" x2="35" y2="20" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="50" y1="30" x2="65" y2="20" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="50" y1="30" x2="30" y2="35" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="50" y1="30" x2="70" y2="35" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="50" y1="30" x2="50" y2="15" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="50" y1="30" x2="50" y2="45" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="50" y1="30" x2="25" y2="25" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="50" y1="30" x2="75" y2="25" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="50" y1="30" x2="40" y2="40" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="50" y1="30" x2="60" y2="40" stroke="#3498db" strokeWidth="0.8" opacity="0.8" />
            <line x1="35" y1="20" x2="25" y2="25" stroke="#3498db" strokeWidth="0.8" opacity="0.7" />
            <line x1="65" y1="20" x2="75" y2="25" stroke="#3498db" strokeWidth="0.8" opacity="0.7" />
            <line x1="30" y1="35" x2="20" y2="40" stroke="#3498db" strokeWidth="0.8" opacity="0.7" />
            <line x1="70" y1="35" x2="80" y2="40" stroke="#3498db" strokeWidth="0.8" opacity="0.7" />
            <line x1="40" y1="40" x2="20" y2="40" stroke="#3498db" strokeWidth="0.8" opacity="0.7" />
            <line x1="60" y1="40" x2="80" y2="40" stroke="#3498db" strokeWidth="0.8" opacity="0.7" />
            <line x1="75" y1="25" x2="85" y2="30" stroke="#3498db" strokeWidth="0.6" opacity="0.6" />
            <line x1="80" y1="40" x2="85" y2="45" stroke="#3498db" strokeWidth="0.6" opacity="0.6" />
            <line x1="80" y1="40" x2="90" y2="35" stroke="#3498db" strokeWidth="0.6" opacity="0.5" />
            <line x1="85" y1="30" x2="88" y2="25" stroke="#3498db" strokeWidth="0.6" opacity="0.5" />
            <line x1="88" y1="25" x2="92" y2="20" stroke="#3498db" strokeWidth="0.4" opacity="0.4" />
            <line x1="90" y1="35" x2="95" y2="30" stroke="#3498db" strokeWidth="0.4" opacity="0.3" />
            <line x1="90" y1="35" x2="93" y2="40" stroke="#3498db" strokeWidth="0.4" opacity="0.4" />
            
            {/* Animated pulse effect for center node */}
            <circle cx="50" cy="30" r="5" fill="#3498db" opacity="0.2">
              <animate attributeName="r" values="5;8;5" dur="2s" repeatCount="indefinite" />
              <animate attributeName="opacity" values="0.2;0.4;0.2" dur="2s" repeatCount="indefinite" />
            </circle>
          </g>
        </g>
        
        {/* Text part */}
        <g transform="translate(0, 65)">
          <text x="90" y="0" fontFamily="Arial" fontSize="20" fontWeight="bold" textAnchor="middle" fill="#ffffff">
            RIVERSIDE AI
          </text>
          <text x="90" y="15" fontFamily="Arial" fontSize="10" fontWeight="normal" textAnchor="middle" fill="#3498db">
            AI AGENCY
          </text>
        </g>
      </svg>
    </div>
  );
};

export default Logo; 